"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTrackingUserId = exports.withAnalyticHandler = exports.handleExternalProviders = exports.isJson = void 0;
exports.isJson = function (str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
var facebookHandler = function (facebookActions, isClientSide) {
    if (isClientSide === void 0) { isClientSide = false; }
    var fbq = (window.fbq) ? window.fbq : function (a, b, c) { return console.log('[Fb Pixel Queue - Mock Endpoint]', a, b, c); };
    facebookActions.map(function (_a) {
        var event = _a.event, action = _a.action, eventJson = _a.eventJson;
        var eventObj = eventJson && exports.isJson(eventJson) ? JSON.parse(eventJson) : eventJson;
        fbq(event, action, eventObj);
    });
};
var gtmHandler = function (googleActions, isClientSide) {
    if (isClientSide === void 0) { isClientSide = false; }
    var resultJson = {};
    googleActions.map(function (_a) {
        var name = _a.name, value = _a.value;
        if (!isNaN(parseFloat(value))) {
            resultJson[name] = value;
        }
        else if (exports.isJson(value)) {
            var jsonValue = JSON.parse(value);
            for (var key in jsonValue) {
                resultJson[name + "." + key] = jsonValue[key];
            }
        }
        else {
            resultJson[name] = value;
        }
    });
    var gtag = window.gtag ? window.gtag : function (a, b, c) { return console.log('[gtag - Mock Endpoint]', a, b, c); };
    var newEvent = JSON.parse(JSON.stringify(resultJson));
    var eventNamePrefix = isClientSide ? '' : 'SERVER_EVENT_';
    if (resultJson.event) {
        delete newEvent.event;
        gtag('event', "" + eventNamePrefix + resultJson.event, newEvent);
    }
    else {
        gtag('event', eventNamePrefix + "INIT", resultJson);
    }
};
// const okayTrackerHandler = (okayActions: { event: string, source?: string, data?: string }[], isClientSide:boolean = false ) => {
//     const okayAnalytics = (window as any).okayAnalytics ? (window as any).okayAnalytics.push : (a: string, b: string, c: any) => console.log('[Okay Analytic Push - Mock Endpoint]', a, b, c)
//     okayActions.map(({ event, source, data }) => {
//         okayAnalytics(event, source, data)
//     })
// }
var handleExternalProviders = function (externalProviders, isClientSide) {
    if (isClientSide === void 0) { isClientSide = false; }
    if (!externalProviders)
        return;
    if (externalProviders.facebook && externalProviders.facebook.facebookPixels && externalProviders.facebook.facebookPixels.length) {
        facebookHandler(externalProviders.facebook.facebookPixels, isClientSide);
    }
    if (externalProviders.google && externalProviders.google.tagManager && externalProviders.google.tagManager.datalayers && externalProviders.google.tagManager.datalayers.length) {
        gtmHandler(externalProviders.google.tagManager.datalayers, isClientSide);
    }
};
exports.handleExternalProviders = handleExternalProviders;
var setTrackingUserId = function (userId) {
    if (!window.okayAnalytics) {
        console.log('okay analytic set userid', userId);
    }
    else {
        window.okayAnalytics.setUserId(userId);
    }
};
exports.setTrackingUserId = setTrackingUserId;
var withAnalyticHandler = function (axiosInstanceCreator) { return function () {
    var instance = axiosInstanceCreator();
    instance.interceptors.response.use(function (response) {
        if (response.data && response.data.externalProviders) {
            handleExternalProviders(response.data.externalProviders);
        }
        return response;
    });
    return instance;
}; };
exports.withAnalyticHandler = withAnalyticHandler;
